import { createAction, props } from "@ngrx/store";

export const imaxxFeatureFlagEnabled = createAction(
  "[ImaxxEligible] Imaxx Feature Flag Enabled",
  props<{ isEnabled: boolean }>()
);

export const imaxxAppModuleEnabled = createAction(
  "[ImaxxEligible] Imaxx AppModule Enabled",
  props<{ isEnabled: boolean }>()
);

export const updateImaxxEnabled = createAction(
  "[ImaxxEligible] Update ImaxxEnabled",
  props<{ isEnabled: boolean }>()
);
